import { SVGProps } from 'react';

export const IconBoxOffice = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.0482 6.72H16.1V5.47882H17.6906C18.0976 5.47882 18.4259 5.07176 18.4259 4.57176V2.90823C18.4259 2.40588 18.0976 2.00117 17.6906 2.00117H13.3482C12.9412 2.00117 12.6141 2.40706 12.6141 2.90823V4.57176C12.6141 5.07294 12.9412 5.47882 13.3482 5.47882H14.9694V6.72H7.12118C6.68588 6.72 6.33294 7.07294 6.33294 7.50588L4.3686 17.66V20.8235H20.837C20.837 20.8235 20.837 18.0929 20.837 17.66L18.8376 7.50588C18.8376 7.07294 18.4847 6.72 18.0482 6.72ZM9.07765 16.1365H7.86471V14.9047H9.07765V16.1365ZM7.86353 13.7835V12.5518H9.07647V13.7835H7.86353ZM11.4306 16.1541H10.2176V14.9047H11.4306V16.1541ZM11.4306 13.7647H10.1988V12.5694H11.4306V13.7647ZM13.7835 16.1518H12.5518V14.9035H13.7835V16.1518ZM12.5518 13.7647V12.5518H13.7835V13.7647H12.5518ZM13.7835 11.4118H7.86471V9.05882H13.7835V11.4118ZM17.2941 11.4118H14.92V10.2118H17.2941V11.4118Z'
        fill='currentColor'
      />
    </svg>
  );
};
